interface BaziReportRequestPerson {
  name: string;
  gender: string;
  birthTime: string;
  lunarDate?: string;
  trueSolarTime?: string;
  birthPlace?: string;
  fourPillars?: string;
}

export type AiRequestGate = 'blocked' | 'allowed';

export const AI_REQUEST_BLOCKED: AiRequestGate = 'blocked';
export const AI_REQUEST_ALLOWED: AiRequestGate = 'allowed';

export type AiRequestGateEvent =
  | { type: 'paipan-succeeded' }
  | { type: 'reset' }
  | { type: 'title-clicked' }
  | { type: 'dayun-changed'; index: number }
  | { type: 'liunian-changed'; year: number }
  | { type: 'liuyue-changed'; month: number };

export function reduceAiRequestGate(
  state: AiRequestGate,
  event: AiRequestGateEvent,
): AiRequestGate {
  if (event.type === 'paipan-succeeded') return AI_REQUEST_ALLOWED;
  if (event.type === 'reset') return AI_REQUEST_BLOCKED;
  return state;
}

export function runAiRequestIfAllowed(
  gate: AiRequestGate,
  request: () => unknown,
): boolean {
  if (gate !== AI_REQUEST_ALLOWED) return false;
  request();
  return true;
}

export function buildBaziReportRequestKey(person?: BaziReportRequestPerson): string {
  if (!person?.name) return '';
  return JSON.stringify([
    person.name,
    person.gender,
    person.birthTime,
    person.lunarDate || '',
    person.trueSolarTime || '',
    person.birthPlace || '',
    person.fourPillars || '',
  ]);
}

export interface RequestGeneration {
  start: () => object;
  invalidate: () => void;
  isCurrent: (generation: object) => boolean;
}

export function createRequestGeneration(): RequestGeneration {
  let current: object | null = null;
  return {
    start: () => {
      const generation = {};
      current = generation;
      return generation;
    },
    invalidate: () => {
      current = null;
    },
    isCurrent: (generation) => current === generation,
  };
}

export type RateLimitPresentation = 'inline-expanded' | 'login-modal';

export function getRateLimitPresentation(isLoggedIn: boolean): RateLimitPresentation {
  return isLoggedIn ? 'inline-expanded' : 'login-modal';
}

export type BaziReportErrorKind = 'rate-limited' | 'request-failed';

export function isBaziReportErrorRetryable(kind: BaziReportErrorKind | null): boolean {
  return kind === 'request-failed';
}
